const READ_SUFFIXES = [':view', ':view_any', ':view_own'];

export function implying(required: string): string[] {
  const separator = required.lastIndexOf(':');
  if (separator <= 0) return [];
  const resource = required.slice(0, separator);
  const action = required.slice(separator);
  if (!READ_SUFFIXES.includes(action)) return [];
  const out = [`${resource}:manage`];
  if (action === ':view_own') out.push(`${resource}:view_any`, `${resource}:view`);
  if (action === ':view_any') out.push(`${resource}:view`);
  return out;
}

export const holds = (held: readonly string[], required: string): boolean =>
  held.includes(required) || implying(required).some((p) => held.includes(p));
